import axios from 'axios';
import { getBaseUrl } from 'shared/helpers/env.js'
/**
 * Get message by id
 * @param {string} messageId - Message id
 * @returns {Promise} - Promise with message
 */
const BASE_URL = getBaseUrl('insite');
export const getMessageById = async (messageId: string) => {
  const response = await axios.get(`${BASE_URL}/n/api/buyer/cs/aichat/message/single/${messageId}`);
  return response.data;
};
